<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label for="modello">
                        {{ trans.get('anomaly.modello') }}
                    </label>
                    <div class="relative w-full">
                        <select name="form.modello"
                                id="modello"
                                v-model="form.modello"
                        >
                            <option :value="harp.cod_articolo"
                                    v-for="harp in harps"
                                    v-text="harp.cod_articolo + ' | ' + harp.descrizione"
                            >
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                        <span class="alert alert-danger"
                              v-if="form.errors.has('modello')"
                              v-text="form.errors.get('modello')"
                        >
                                </span>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label for="data">
                        {{ trans.get('anomaly.data') }}
                    </label>
                    <date-picker
                            v-model="date"
                            :options="{firstDay: 1}"
                    >

                    </date-picker>
                    <span class="alert alert-danger"
                          v-if="form.errors.has('data')"
                          v-text="form.errors.get('data')"
                    >
                            </span>
                </div>
            </div>
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label for="parte_1">
                        {{ trans.get('anomaly.num_parte') }}
                    </label>
                    <div class="relative w-full">
                        <select name="form.parte_1"
                                id="parte_"
                                v-model="form.parte_1"
                        >
                            <option :value="pnumber.num_parte"
                                    v-for="pnumber in pnumbers"
                                    v-text="pnumber.num_parte + ' | ' + pnumber.descrizione"
                            >
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label for="data">
                        {{ trans.get('anomaly.cod_parte') }}
                    </label>
                    <ais-instant-search
                            :search-client="searchClient"
                            index-name="items"
                    >
                        <ais-configure
                                :hits-per-page.camel="5"
                                :restrict-searchable-attributes.camel="['descrizione', 'id_articolo']"
                        />
                        <ais-autocomplete>
                            <template slot-scope="{ currentRefinement, indices, refine }">
                                <vue-autosuggest
                                        :suggestions="indicesToSuggestions(indices)"
                                        v-model="form.cod_articolo_parte_1"
                                        @input="refine"
                                        @selected="onSelect"
                                        :input-props="{
                                                    style: 'width: 100%',
                                                    placeholder: 'Search here…',
                                                }"
                                        :get-suggestion-value="getSuggestionValue"
                                >
                                    <template slot-scope="{ suggestion }">
                                        <div>
                                            <strong>{{ suggestion.item.id_articolo }}</strong> - {{
                                            suggestion.item.descrizione }}
                                        </div>
                                    </template>
                                </vue-autosuggest>
                            </template>
                        </ais-autocomplete>
                    </ais-instant-search>
                </div>
            </div>
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label for="assembly">
                        {{ trans.get('anomaly.assembly_num_parte') }}
                    </label>
                    <div class="relative w-full">
                        <select name="assembly"
                                id="assembly"
                                v-model="form.assembly"
                        >
                            <option :value="pnumber.num_parte"
                                    v-for="pnumber in pnumbers"
                                    v-text="pnumber.num_parte + ' | ' + pnumber.descrizione"
                            >
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label for="data">
                        {{ trans.get('anomaly.assembly_cod_parte') }}
                    </label>
                    <ais-instant-search
                            :search-client="searchClient"
                            index-name="items"
                    >
                        <ais-configure
                                :hits-per-page.camel="5"
                                :restrict-searchable-attributes.camel="['descrizione', 'id_articolo']"
                        />
                        <ais-autocomplete>
                            <template slot-scope="{ currentRefinement, indices, refine }">
                                <vue-autosuggest
                                        :suggestions="indicesToSuggestions(indices)"
                                        v-model="form.cod_articolo_assembly"
                                        @input="refine"
                                        @selected="onSelectAssembly"
                                        :input-props="{
                                                    style: 'width: 100%',
                                                    placeholder: 'Search here…',
                                                }"
                                        :get-suggestion-value="getSuggestionValue"
                                >
                                    <template slot-scope="{ suggestion }">
                                        <div>
                                            <strong>{{ suggestion.item.id_articolo }}</strong> - {{
                                            suggestion.item.descrizione }}
                                        </div>
                                    </template>
                                </vue-autosuggest>
                            </template>
                        </ais-autocomplete>
                    </ais-instant-search>
                </div>
            </div>
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label for="stadio">
                        {{ trans.get('anomaly.stadio') }}
                    </label>
                    <div class="relative w-full">
                        <select name="form.stadio"
                                id="stadio"
                                v-model="form.stadio"
                        >
                            <option value="SL" selected>{{ trans.get('anomaly.SL') }}</option>
                            <option value="AAL">{{ trans.get('anomaly.AAL') }}</option>
                            <option value="AAP">{{ trans.get('anomaly.AAP') }}</option>
                            <option value="AAV">{{ trans.get('anomaly.AAV') }}</option>
                            <option value="AAS">{{ trans.get('anomaly.AAS') }}</option>
                            <option value="AA-">{{ trans.get('anomaly.AA-') }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label for="quantita">
                        {{ trans.get('anomaly.quantita') }}
                    </label>
                    <input type="text"
                           name="quantita"
                           id="quantita"
                           :placeholder="trans.get('anomaly.qta_placeholder')"
                           v-model.number="form.quantita"
                           @keydown="form.errors.clear($event.target.name)"
                    >
                    <span class="alert alert-danger"
                          v-if="form.errors.has('quantita')"
                          v-text="form.errors.get('quantita')"
                    >
                            </span>
                </div>
            </div>
            <div class="w-full flex p-4 justify-start flex-grow-0"
                 :class="!showLow && !showCritical ? 'justify-between' : 'justify_start'"
            >
                <transition name="slide-fade">
                    <div class="modal-form-card modal-form-card-low"
                         v-if="showLow"
                         @click="() => {
                                    showMedium = !showMedium;
                                    showCritical = !showCritical;
                                    form.livello = 'basso'
                                    form.passa = true
                                    form.rilavorazione = false
                                    }"
                    >
                        <h3>{{ trans.get('anomaly.basso')}}</h3>
                        <section>
                            {{ trans.get('anomaly.basso_description') }}
                        </section>
                    </div>
                </transition>
                <div class="modal-form-card  modal-form-card-medium"
                     v-if="showMedium"
                     @click="() => {
                                    showLow = !showLow;
                                    showCritical = !showCritical;
                                    form.livello = 'medio'
                                    form.passa = false
                                    form.rilavorazione = true
                                    }"
                >
                    <h3>{{ trans.get('anomaly.medio')}}</h3>
                    <section>
                        {{ trans.get('anomaly.medio_description') }}
                    </section>
                </div>
                <transition name="slide-fade">
                    <div class="modal-form-card modal-form-card-critical"
                         v-if="showCritical"
                         @click="() => {
                                        showLow = !showLow;
                                        showMedium = !showMedium;
                                        form.livello = 'critico'
                                        form.passa = false
                                        form.rilavorazione = false
                                        }"
                    >
                        <h3>{{ trans.get('anomaly.critico')}}</h3>
                        <section>
                            {{ trans.get('anomaly.critico_description') }}
                        </section>
                    </div>
                </transition>
                <transition name="slide-fade">
                    <div class="modal-form-rework"
                         v-if="!showLow && !showCritical"
                    >
                        <section class="flex flex-col justify-between">
                            <label for="tempo_rilavorazione"
                                   class="uppercase text-gray-700 py-2"
                            >
                                {{ trans.get('anomaly.tempo_rilavorazione') }}
                            </label>
                            <input type="text"
                                   name="tempo_lavorazione"
                                   id="tempo_lavorazione"
                                   :placeholder="trans.get('anomaly.tl_placeholder')"
                                   v-model.number="form.tempo_rilavorazione"
                                   class="py-2 pl-4 appearance-none border border-gray-400 shadow tracking-wide"
                            >
                            <div class="mt-2">
                                <input type="checkbox"
                                       name="scarto_parte_1"
                                       id="scarto_parte_1"
                                       v-model="form.scarto_parte_1"
                                >
                                <span class="uppercase text-gray-700 py-2">
                                    {{ trans.get('anomaly.scarto_parte_1') }}
                                </span>
                            </div>
                        </section>
                    </div>
                </transition>
            </div>
            <div class="modal-form-block">
                <label for="dettaglio">
                    {{ trans.get('anomaly.dettaglio') }}
                </label>
                <vue-trix
                        v-model="form.dettaglio"
                        name="dettaglio"
                        :trix-blur="() => {this.form.errors.clear('dettaglio')}"
                >

                </vue-trix>
                <span class="alert alert-danger"
                      v-if="form.errors.has('dettaglio')"
                      v-text="form.errors.get('dettaglio')"
                ></span>
            </div>
            <div class="modal-form-block">
                <label for="argomento">
                    {{ trans.get('anomaly.argomento') }}
                </label>
                <vue-trix v-model="form.argomento"></vue-trix>
            </div>
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label for="tipo_anomalia">
                        {{ trans.get('anomaly.tipo_anomalia') }}
                    </label>
                    <div class="relative w-full">
                        <select name="form.tipo_anomalia"
                                id="tipo_anomalia"
                                v-model="form.tipo_anomalia"
                        >
                            <option :value="reason.causale"
                                    v-for="reason in reasons"
                                    v-text="reason.causale + ' | ' + reason.descrizione"
                            >
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label for="categoria">
                        {{ trans.get('anomaly.categoria') }}
                    </label>
                    <input type="text"
                           name="categoria"
                           id="categoria"
                           :placeholder="trans.get('anomaly.cat_placeholder')"
                           v-model="form.categoria"
                    >
                    <span class="alert alert-danger"
                          v-if="form.errors.has('categoria')"
                          v-text="form.errors.get('categoria')"
                    >
                    </span>
                </div>
                <div class="modal-form-block">
                    <label for="chs">
                        Client/House/Supplier:
                    </label>
                    <div class="relative w-full">
                        <select name="form.chs"
                                id="chs"
                                v-model="form.chs"
                        >
                            <option>C</option>
                            <option selected>H</option>
                            <option>S</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-form-block mt-6 mb-6">
                <button class="w-full btn is-aitems-700">
                    {{ trans.get('anomaly.crea') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import DatePicker from '../DatePicker';
    import moment from 'moment';
    import Searchable from "../../mixins/Searchable";
    import VueTrix from "../utilities/VueTrix";

    export default {

        mixins: [Searchable],

        components: {DatePicker, VueTrix},

        data() {
            return {
                form: new Form({
                    chs: '',
                    data_creazione: '',
                    modello: '',
                    categoria: '',
                    stadio: '',
                    parte_1: '',
                    des_parte_1: '',
                    cod_articolo_parte_1: '',
                    des_articolo_parte_1: '',
                    costo_parte_1: '',
                    assembly: '',
                    des_assembly: '',
                    cod_articolo_assembly: '',
                    des_articolo_assembly: '',
                    costo_assembly: '',
                    costo_totale: 0,
                    quantita: '',
                    dettaglio: '',
                    argomento: '',
                    passa: false,
                    rilavorazione: false,
                    tempo_rilavorazione: '',
                    scarto_parte_1: false,
                    livello: '',
                    tipo_anomalia: '',
                    codice: '',
                }),
                pnumbers: {},
                harps: {},
                reasons: {},
                date: moment().format('DD-MM-YYYY'),
                domain: process.env.MIX_API_DOMAIN,
                step1: true,
                step2: false,
                id: '',
                showLow: true,
                showMedium: true,
                showCritical: true
            }
        },

        computed: {
            id_anomaly() {
                return `${this.form.tipo_anomalia}.${this.form.parte_1}.${moment().format('MMYY')}`
            },

            reverseDate() {
                return this.date.split('-').reverse().join('-');
            },

            id_articolo() {
                return this.form.cod_articolo_parte_1;
            },

            id_assembly() {
                return this.form.cod_articolo_assembly;
            },
        },

        created() {
            axios.get('/part-numbers')
                .then(({data}) => this.pnumbers = data);
            axios.get('/harps')
                .then(({data}) => this.harps = data);
            axios.get('/qms/reason')
                .then(({data}) => this.reasons = data);
            this.debouceGetItem = _.debounce((target) => {
                this.getItemData(target)
            }, 3000);
        },

        watch: {
            id_articolo() {
                this.debouceGetItem('parte_1');
            },

            id_assembly() {
                this.debouceGetItem('assembly');
            }
        },

        methods: {
            onSelect(selected) {
                if (selected) {
                    this.form.cod_articolo_parte_1 = selected.item.id_articolo;
                    this.form.parte_1 = selected.item.part_number;
                }
            },
            onSelectAssembly(selected) {
                if (selected) {
                    this.form.cod_articolo_assembly = selected.item.id_articolo;
                    this.form.assembly = selected.item.part_number;
                }
            },
            getItemData(target) {

                axios.get('/items/' + this.form[`cod_articolo_${target}`])
                    .then(({data}) => this.form[`des_articolo_${target}`] = data.descrizione)
                    .catch(() => {
                        console.log('Descrizione Articolo Non Trovato');
                        this.$toastr.e(this.trans.get('anomaly.item_desc_not_found'));
                        this.form[`des_articolo_${target}`] = 'Non Trovato'
                    });
                axios.get('/part-numbers/' + this.form[target])
                    .then(({data}) => this.form[`des_${target}`] = data.descrizione)
                    .catch(() => {
                        console.log('Descrizione Parte Non Trovata');
                        this.$toastr.e(this.trans.get('anomaly.pn_desc_not_found'));
                        this.form[`des_${target}`] = 'Non Trovato'
                    });

                axios.get(`${this.domain}/articoli/` + this.form[`cod_articolo_${target}`])
                    .then(({data}) => {
                        this.form[`costo_${target}`] = parseFloat(data.data[0].costo);
                    })
                    .catch(() => {
                        console.log('Costo non trovato');
                        this.$toastr.e(this.trans.get('anomaly.api_cost_error'));
                        this.form[`costo_${target}`] = 1
                    })
            },
            totale() {
                if (this.form.costo_assembly) {
                    return this.form.quantita * this.form.costo_assembly;
                }
                return this.form.quantita * this.form.costo_parte_1;
            },
            prepareData() {
                this.form.codice = this.id_anomaly;
                this.form.data_creazione = this.reverseDate;
                if (this.form.livello === 'critico') {
                    console.log(this.totale());
                    this.form.costo_totale = this.totale();
                }
            },
            onSubmit() {
                this.prepareData();

                this.form.post('/qms/anomalies')
                    .then(anomaly => {
                        this.redirect(anomaly.id)
                    })
                    .catch(error => {
                        console.log(error.errors);
                        this.form.onFail(error.errors);
                    });
            },

            redirect(id) {
                window.location.href = `/qms/anomalies/${id}/edit`;
            }
        }
    }
</script>

<style scoped lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translate(10px);
        opacity: 0;
    }

    p {
        @apply mr-2 p-2;
    }

    .alert {
        @apply text-xs mt-1 capitalize;
    }

    .alert-danger {
        @apply text-red-400;
    }

    .modal-form-card {
        @apply w-1/3 mr-2 flex flex-col px-4 border rounded py-4 cursor-pointer;

        h3 {
            @apply mb-2 text-2xl font-bold tracking-wide;
        }

        &-low {
            @apply bg-green-200 border-green-300;

            h3 {
                @apply text-green-700;
            }

            section {
                @apply text-green-600;
            }
        }

        &-medium {
            @apply bg-yellow-200 border-yellow-300;

            h3 {
                @apply text-yellow-700;
            }

            section {
                @apply text-yellow-600;
            }
        }

        &-critical {
            @apply bg-red-200 border-red-300;

            h3 {
                @apply text-red-700;
            }

            section {
                @apply text-red-600;
            }
        }

        &:last-child {
            @apply mr-0;
        }
    }

    .modal-form-rework {
        @apply w-1/3 mr-2 flex flex-col px-4 border border-yellow-300 rounded py-4 cursor-pointer shadow;
    }
</style>
